export function readJiraCreateWarning(state: unknown): string | null {
    if (!state || typeof state !== 'object' || !('jiraWarning' in state)) {
        return null;
    }
    const warning = (state as { jiraWarning?: unknown }).jiraWarning;
    if (typeof warning !== 'string' || warning.length === 0) {
        return null;
    }
    return warning;
}
